export default __webpack_public_path__ + "static/media/icon_arrow-right.f8e94dc8.svg";